import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth';
import { Router } from '@angular/router';
import { SETTINGS } from '../../../core/config/common.settings';
import { ChargebeeService } from '../../../core/services/chargebee.service';
import { MessageService } from 'primeng/api';
import { SubscriberService } from '../../../core/services/subscriber.service';

declare var Chargebee: any;
@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  providers: [MessageService]
})
export class PortalComponent implements OnInit {

  brand: any;
  constructor(
    private subscriberService: SubscriberService,
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService,
    private chargebeeService: ChargebeeService
  ) {}

  ngOnInit(): void {
    // this.findBrand().then( (r: any) => {
    //   this.brand = r;
    //   this.onClickManage();
    // });
    this.onClickManage();
  }

  // onClickManage(): void {
  //   //portal
  //   Chargebee.init({
  //       site: SETTINGS.CHARGEBEE_SITE,
  //     isItemsModel: true,
  //   });
  //   const cbInstance = Chargebee.getInstance();
  //   const cbPortal = cbInstance.createChargebeePortal();
  //   const {payment} = this.brand;
  //   const baseUrl = window.location.origin;
  //
  //   cbPortal.open({
  //     customerId: payment.customerId,
  //     redirectUrl: `${baseUrl}/admin`,
  //     loaded: () => {
  //       console.log('✅ Portal has loaded.');
  //     },
  //
  //     success: (data: any) => {
  //       console.log('🎉 Portal action successful:');
  //     },
  //
  //     close: () => {
  //       console.log('❎ Portal was closed.');
  //       this.router.navigate(['/admin']);
  //     },
  //   });
  // }

  onClickManage(): void {
    //portal sessions
    Chargebee.init({
      site: SETTINGS.CHARGEBEE_SITE,
      isItemsModel: true,
    });
    const cbInstance = Chargebee.getInstance();
    cbInstance.setPortalSession( () => this.getPortalSession());
    const cbPortal = cbInstance.createChargebeePortal();
    const baseUrl = window.location.origin;

    cbPortal.open({
      redirectUrl: `${baseUrl}/admin/`,
      loaded: () => {
        console.log('Portal has loaded.');
      },

      success: (data: any) => {
        console.log('Portal action successful:');
        window.location.href = `${baseUrl}/admin/company-configuration`;
      },

      close: () => {
        console.log('Portal was closed.');
        window.location.href = `${baseUrl}/admin/user-management`;
      },
    });
  }

  async findBrand(): Promise<void> {
    try {
      const user = await this.authService.getLoggedInUser();
      this.brand = await this.subscriberService.findSubscriber(user.userId);
    } catch (e) {}
  }

  async getPortalSession(): Promise<any> {
    try {
      return await this.chargebeeService.createPortalSession();
    } catch (e: any) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: e?.message || e
      });
    }
  }

}
